'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = drawLine;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _drawLineHtml = require('./draw-line.html');

var _drawLineHtml2 = _interopRequireDefault(_drawLineHtml);

function drawLine() {
	var directive = {
		restrict: 'E',
		template: _drawLineHtml2['default'],
		link: link,
		scope: {
			points: '=',
			clickHandler: '=',
			redraw: '=',
			offsetLeft: '='
		}
	};

	return directive;

	function link(scope, element) {
		if (!scope.clickHandler) {
			scope.clickHandler = function () {
				console.log('You haven\'t specified a clickHandler for the draw_lines directive');
			};
		}

		var radius = 20 * Math.PI / 2;

		/**
  * Passes the event and the selected point to the designated clickHandler
  */
		element[0].addEventListener('click', handleClick);
		function handleClick(e) {
			scope.points.forEach(function (value, index) {

				// Check X
				if (e.layerX >= value.x - radius && e.layerX <= value.x + radius) {
					// Check Y
					if (e.layerY >= value.y && e.layerY <= value.y + radius * 4) {
						scope.clickHandler(e, scope.points[index], index);
						_drawLine(scope.points);
					}
				}
			});
		}

		//  && e.layerY <= value.y + radius

		_drawLine(scope.points, scope.clickHandler);
		scope.redraw = function () {
			var points = arguments.length <= 0 || arguments[0] === undefined ? scope.points : arguments[0];

			scope.points = points;
			_drawLine(scope.points, scope.clickHandler);
		};

		function _drawLine(points) {
			// Initialize Canvas
			var canvas = document.getElementById('draw-line');
			var ctx = canvas.getContext('2d');
			ctx.canvas.width = window.innerWidth - scope.offsetLeft;
			ctx.canvas.height = 180;

			if (ctx.canvas.width < points.length * 100) {
				ctx.canvas.width = points.length * 100;
			}

			var centerY = canvas.height / 2;
			var canvasWidth = ctx.canvas.width;

			// Set font
			ctx.font = '1.2em Arial';

			// Draw the line
			var roadImage = new Image();
			roadImage.src = '/assets/images/Road.png';
			roadImage.onload = function () {
				var images = Math.ceil(canvasWidth / roadImage.width) * 2;
				for (var i = 0; i < images; i++) {
					ctx.drawImage(roadImage, roadImage.width / 2 * i, centerY - roadImage.height / 4, roadImage.width / 2, roadImage.height * 0.5);
				}
			};

			// Draw the points
			points.forEach(function (value, index) {
				var position = undefined;
				var positionText = undefined;

				// Calculate the point and text X position
				if (index === points.length - 1 && points.length > 1) {
					position = canvasWidth - (radius + 1);
					var cityTextWidth = ctx.measureText(value.name).width;
					var stationNameWidth = ctx.measureText('(' + value.station.name + ')').width;
					positionText = position - (cityTextWidth > stationNameWidth ? cityTextWidth : stationNameWidth) + radius + 1;
				} else if (index === 0) {
					position = radius + 1;
					positionText = position - radius + 1;
				} else {
					position = canvasWidth / points.length * index + (radius + 1);
					positionText = position - ctx.measureText(value.name).width / 2;
				}

				var pointX = position;
				// Save the x position so that we can use it for inputs
				scope.points[index].posX = position;
				scope.points[index].radius = radius;

				// Calculate the text Y position
				var cityTextY = index % 2 === 0 ? centerY - radius * 2 - 5 : centerY + radius * 2;

				value.x = pointX;
				value.y = centerY;

				var busImage = new Image();
				var iconSrc = value.active ? '/assets/images/Bus-Selected.png' : '/assets/images/Bus-Not-Selected.png';
				busImage.src = iconSrc;
				busImage.onload = function () {
					ctx.drawImage(busImage, pointX - radius, centerY - radius, radius * 2, radius * 2);

					// Set, fill and stroke the circle
					ctx.arc(pointX, centerY, radius, 0, 2 * Math.PI);

					// Set city name
					ctx.fillText(value.name, positionText, cityTextY);
					// Set station name
					ctx.fillText('(' + value.station.name + ')', positionText, cityTextY + 15);
				};
			});
		}
	}
}

module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/draw-line/draw-line.directive.js
 **/